/**
 * @generated SignedSource<<2d15adb7c881dee6e999cb7194d1b624>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RoadmapNavExpanded_query$data = {
  readonly roadmapsOrder?: {
    readonly " $fragmentSpreads": FragmentRefs<"RoadmapsContent_navigationCustomisation">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapsContent">;
  readonly " $fragmentType": "RoadmapNavExpanded_query";
};
export type RoadmapNavExpanded_query$key = {
  readonly " $data"?: RoadmapNavExpanded_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapNavExpanded_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURL"
    },
    {
      "kind": "RootArgument",
      "name": "entityAriRoadmaps"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    }
  ],
  "kind": "Fragment",
  "name": "RoadmapNavExpanded_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentURL",
          "variableName": "currentURL"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RoadmapsContent"
    },
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "roadmapsOrder",
          "args": [
            {
              "kind": "Variable",
              "name": "entityAri",
              "variableName": "entityAriRoadmaps"
            },
            {
              "kind": "Variable",
              "name": "ownerAri",
              "variableName": "ownerAri"
            }
          ],
          "concreteType": "SettingsNavigationCustomisation",
          "kind": "LinkedField",
          "name": "settings_navigationCustomisation",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "RoadmapsContent_navigationCustomisation"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "6ce248349f18ac34c1458ab0e14ad778";

export default node;
